import { Button, Flex, Form, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import DeleteIcon from "../../../../assets/icons/DeleteIcon";
import AddIcon from "../_icons/AddIcon";

export default function ExperienceInfo() {
  return (
    <Form.List initialValue={[{}]} name="experiences">
      {(fields, { add, remove }) => {
        return (
          <>
            {fields.map(({ key, name, ...restField }, _) => {
              return (
                <div
                  key={key}
                  className="p-4 rounded-lg border border-theme-zinc-200 mb-3"
                >
                  {fields.length > 1 && (
                    <Flex justify="end">
                      <Button
                        icon={<DeleteIcon className="text-theme-red-500" />}
                        onClick={() => remove(name)}
                        size="small"
                        type="dashed"
                        className="!size-7"
                      />
                    </Flex>
                  )}
                  <Form.Item
                    {...restField}
                    label="চাকুরীর পদবি"
                    name={[name, "jobTitle"]}
                    rules={[
                      {
                        required: true,
                        message: "চাকুরীর পদবি দিন",
                      },
                    ]}
                  >
                    <Input size="large" placeholder="যেমনঃ লাইন ম্যানেজার" />
                  </Form.Item>

                  <div className="grid md:grid-cols-2 gap-5">
                    <Form.Item
                      {...restField}
                      label="কোম্পানি/প্রতিষ্ঠান"
                      name={[name, "company"]}
                      rules={[
                        {
                          required: true,
                          message: "কোম্পানি/প্রতিষ্ঠান নাম দিন",
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        placeholder="কোম্পানি/প্রতিষ্ঠান নাম লিখুন"
                      />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      label="কত বছরের আভিজ্ঞতা"
                      name={[name, "totalYears"]}
                      rules={[
                        {
                          required: true,
                          message: "আভিজ্ঞতা দিন",
                        },
                        {
                          validator: (_, value) => {
                            if (!value) return Promise.resolve();
                            const numValue = Number(value);
                            if (numValue < 0) {
                              return Promise.reject(
                                new Error("আভিজ্ঞতা ঋণাত্মক হতে পারে না")
                              );
                            }
                            if (numValue > 60) {
                              return Promise.reject(
                                new Error("অভিজ্ঞতা ৬০ বছরের বেশি হতে পারে না")
                              );
                            }
                            if (
                              value.toString().includes(".") &&
                              value.toString().split(".")[1].length > 1
                            ) {
                              return Promise.reject(
                                new Error(
                                  "দশমিকের পর মাত্র একটি সংখ্যা গ্রহণযোগ্য"
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        size="large"
                        placeholder="আভিজ্ঞতা লিখুন (বছরে)"
                      />
                    </Form.Item>
                  </div>

                  <Form.Item
                    {...restField}
                    label="কাজের বিবরণ"
                    name={[name, "description"]}
                    rules={[
                      {
                        required: false,
                        message: "কাজের বিবরণ দিন",
                      },
                    ]}
                  >
                    <TextArea
                      rows={4}
                      placeholder="কাজের বিবরণ..."
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </div>
              );
            })}

            <Button
              size="small"
              type="text"
              icon={<AddIcon />}
              onClick={() => add()}
              className="!bg-transparent"
            >
              <span className="text-theme-blue-600 text-lg font-medium relative -top-[1px] ml-1">
                আরো যুক্ত করুন
              </span>
            </Button>
          </>
        );
      }}
    </Form.List>
  );
}
